import { render, staticRenderFns } from "./Litigations.vue?vue&type=template&id=13b29b7e&scoped=true&"
import script from "./Litigations.vue?vue&type=script&lang=js&"
export * from "./Litigations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b29b7e",
  null
  
)

export default component.exports